import React, { useState } from "react";
import {
    ListSubheader,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Breadcrumbs,
    Link,
    Radio,
    Box
} from "@mui/material";
import FolderIcon from "@mui/icons-material/Folder";
import HomeIcon from '@mui/icons-material/Home';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CancelIcon from '@mui/icons-material/Cancel';

function Subheader({ sub, fetchFolder, setSub }) {
    return (
        <ListSubheader sx={{ position: 'relative', padding: '5px 5px 0px 10px' }}>
            <Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: "12px" }}>
                {sub?.length > 0 &&
                    <HomeIcon
                        sx={{
                            color: "grey",
                            "&:hover": {
                                cursor: "pointer",
                            },
                        }}
                        fontSize="small"
                        onClick={() => {
                            setSub([]);
                            fetchFolder(null);
                        }} />}
                {sub.map((s, index) => (
                    <Link
                        component="button"
                        variant="body2"
                        underline="hover"
                        color="inherit"
                        key={index}
                        onClick={() => {
                            setSub(sub?.filter((_, i) => i <= index));
                            fetchFolder(s?.directory_id)
                        }}>
                        {s?.name}
                    </Link>
                ))}
            </Breadcrumbs>
            {/* <Box
                sx={{ position: 'absolute', top: -14, right: -14, padding: '10px 10px', width: '100%', display: 'flex', justifyContent: 'end' }}>
                <CancelIcon color="error" fontSize="small" sx={{ cursor: 'pointer' }} />
            </Box> */}
        </ListSubheader>
    );
}

function FolderList({ sub, data, folder, onClick, fetchFolder, setSub }) {

    const handleToggle = (f) => {
        onClick(f);
    };

    return (
        <List>
            {data?.length > 0 ? data?.map((f, i) => (
                <React.Fragment key={i}>
                    <ListItemButton
                        sx={{
                            padding: "0px 0px 0px 10px",
                            borderRadius: "5px",
                            "&:hover": {
                                backgroundColor: "lightgrey",
                            },
                            "&.Mui-selected": {
                                backgroundColor: "grey",
                                "&:hover": {
                                    backgroundColor: "darkgrey",
                                },
                            },
                        }}
                        onClick={() => handleToggle(f)}
                    >
                        <ListItemIcon>
                            <FolderIcon sx={{ color: "#ff9800" }} />
                        </ListItemIcon>
                        <ListItemText primary={<Link
                            component="button"
                            variant="body2"
                            underline="hover"
                            color="inherit"
                            onClick={() => {
                                if (!sub?.map(s => s?.directory_id)?.includes(f?.directory_id)) {
                                    setSub([...sub, f]);
                                }
                                fetchFolder(f?.directory_id);
                            }}
                        >
                            {f?.name}
                        </Link>} />
                        <Radio checked={f?.directory_id === folder?.value?.directory_id} />
                    </ListItemButton>
                </React.Fragment>
            )) : <ListItemButton
                sx={{
                    borderRadius: "5px",
                }}>
                <ListItemIcon><WarningAmberIcon fontSize="small" /></ListItemIcon>
                <ListItemText primary={<Link
                    underline="none"
                    color="inherit"
                    variant="body2">No Content</Link>} /></ListItemButton>}
        </List>
    );
}

export default function FolderStructure(props) {

    const [sub, setSub] = useState([]);
    const { folders, folder, onSelect, fetchFolder } = props;

    return (
        <List subheader={<Subheader sub={sub} fetchFolder={fetchFolder} setSub={setSub} />}>
            <FolderList data={folders} folder={folder} onClick={onSelect} fetchFolder={fetchFolder} sub={sub} setSub={setSub} />
        </List>
    );
}